import React, { useEffect, useRef, useState, lazy } from "react";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  ButtonGroup,
  Typography,
  Grid,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  Box,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import Layout from "../../layout/Layout";

// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ListIcon from "@mui/icons-material/List";
import GridViewIcon from "@mui/icons-material/GridView";
import GetAppIcon from "@mui/icons-material/GetApp";

// import UserCardComponent from "../Components/UserCardComponent";
// import UserListComponent from "../Components/UserListComponent";

import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import UserAvatar from "../../components/UserAvatar";
import TicketCard from "../../components/TicketCard";
import {
  agentDashboardAPI,
  userDashboardAPI,
  config,
  statusAPI,
  usersAPI,
  userData,
} from "../../config";
import { Search, Edit } from "@mui/icons-material";
import { Link, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx/xlsx.mjs";
import Backdrop from "@mui/material/Backdrop";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const STATUS_COLOR_LEGEND = [
  { color: "#0097a7", label: "Open (Created by Admin)" },
  { color: "#ad1457", label: "Open" },
  { color: "#ed6c02", label: "Pending by User" },
  { color: "#7b1fa2", label: "Pending by IT Admin" },
  { color: "#f9a825", label: "On Hold" },
  { color: "#2e7d32", label: "Closed" },
  { color: "#0288d1", label: "Pending" },
  { color: "#00796b", label: "Pending by Vendor" },
  { color: "#c62828", label: "Unresolved" },
];

// let intOffset = 0;
export default function TicketList() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [totalCount, setTotalCount] = useState(0);

  const [checked, setChecked] = useState([0]);

  const [intAgentID, setAgentID] = React.useState(() => parseInt(searchParams.get("agentId")) || 0);
  const [agentList, setAgentList] = React.useState([]);
  const [fromDate, setFromDate] = useState(() => searchParams.get("fromDate") || "");
  const [toDate, setToDate] = useState(() => searchParams.get("toDate") || "");
  const [selectedAgentObj, setSelectedAgentObj] = useState(null);
  const [isAdminState, setIsAdminState] = useState(() => searchParams.get("isAdmin") || null);

  const editPageBaseURL =
    userData.role === "user" ? "/user/ticket/list/" : "/agent/list/";

  const handleToggle1 = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const [personName, setPersonName] = useState([]);

  const [layoutStyle, setLayoutStyle] = useState("grid");

  const [ticketList, setTicketList] = useState([]);
  const [ticketData, setTicketData] = useState(null);
  const [newReplies, setNewReplies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let assetsRef = useRef(false);
  // Replaced manual mount fetch with MRT useEffect + State Initializers
  useEffect(() => {
    assetsRef.current = true;
    return () => {
      assetsRef.current = false;
    };
  }, []);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);

  const [excelLoading, setExcelLoading] = useState(false);
  const [exportSuccess, setExportSuccess] = useState(false);

  useEffect(() => {
    fetchData(1);
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, sorting, columnFilters]);

  // FILTER START

  
  // All filter states now hold full objects (or null) for Autocomplete compatibility
  const [issueType, setIssueType] = useState(null);
  const [issueSubType, setIssueSubType] = useState(null);
  const [department, setDepartment] = useState(null);
  const [prioritization, setPrioritization] = useState(null);
  const [statusID, setStatusID] = useState(() => searchParams.get("id"));

  const [issueTypeList, setIssueTypeList] = useState([]);
  const [issueSubTypeList, setIssueSubTypeList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [prioritizationList, setPrioritizationList] = useState([]);
  const [statusList, setStatusList] = useState([]),
    [userList, setUserList] = useState([]),
    [userID, setUserID] = useState(0);

  let filterUseRef = useRef(false);

  useEffect(() => {
    if (filterUseRef.current === false) {
      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "1",
      });
      getStatus(data, "issueTypeList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "35",
      });
      getStatus(data, "departmentList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "33",
      });
      getStatus(data, "prioritizationList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "43",
      });
      getStatus(data, "statusList");

      const intDepartmentFromURL = searchParams.get("deptId");
      const intDepartment = parseInt(intDepartmentFromURL || userData.department);

      data = JSON.stringify({
        intSPType: userData.departmenthead === 1 ? 21 : 16,
        intUserID: userData.role === "user" ? userData.id : null,
        intDepartment: userData.role === "user" || intDepartmentFromURL ? intDepartment : null,
        intLimit: 10,
        intOffset: 0
      });
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          // Set department if deptId is in URL
          const deptIdFromURL = searchParams.get("deptId");
          if (deptIdFromURL && response.data["data"]) {
            const matchedDept = response.data["data"].find(d => d.id === parseInt(deptIdFromURL));
            if (matchedDept) setDepartment(matchedDept);
          }
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      // Fetch Agents
      const agentPayload = JSON.stringify({
        intSPType: 16,
      });
      config.method = "PATCH";
      config.data = agentPayload;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          const agents = response.data["data"] || [];
          setAgentList(agents);
          const agentIdParam = searchParams.get("agentId");
          if (agentIdParam) {
            const matchedAgent = agents.find(a => a.id === parseInt(agentIdParam));
            if (matchedAgent) setSelectedAgentObj(matchedAgent);
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      getUsers(data);

      return () => {
        filterUseRef.current = true;
      };
    }
  }, []);

  const optionsAgent = agentList?.map((option) => {
    if (option.name !== null) {
      const firstLetter = option?.name?.[0].toUpperCase();
      return {
        firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
        ...option,
      };
    }
  });

  const getUsers = (data) => {
    config.method = "PATCH";
    config.data = data;
    config.url = usersAPI;

    axios(config)
      .then(function (response) {
        setUserList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  // Issue Type change: fetch sub-types based on selected type
  const handleIssueTypeChange = (event, newValue) => {
    setIssueType(newValue);
    setIssueSubType(null);
    setIssueSubTypeList([]);
    if (newValue) {
      const data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: newValue.id,
      });
      getStatus(data, "issueSubTypeList");
    }
  };

  const fetchData = (action) => {
    if (action === 1) {
      setPagination(prev => ({ ...prev, pageIndex: 0 }));
    }
    const intDepartment = parseInt(userData.department);

    const colFilters = {};
    columnFilters.forEach((filter) => {
      const keyMap = {
        ticketID: "filterTicketID",
        ticketSubject: "filterSubject",
        ticketCreatedUserName: "filterEmpName",
        ticketCategory: "filterCategory",
        department: "filterDepartment",
        statusName: "filterStatusName",
        ticketType: "filterPrioritization",
        agent_name: "filterAgentName",
        assigned_by_name: "filterAdminTime",
        approvalStatus: "filterReview",
        lastAgentReplyName: "filterSubCategory",
        created_at: "filterLastReplyDate",
      };
      if (keyMap[filter.id]) {
        colFilters[keyMap[filter.id]] = filter.value;
      }
    });

    const data = JSON.stringify({
      intAgentID: userData.role === "agent" ? userData.id : intAgentID,
      intLimit: pagination.pageSize,
      intOffset: (action === 1 ? 0 : pagination.pageIndex) * pagination.pageSize,
      intSPType:
        (userData.role === "user" && userData.departmenthead === 0)
          ? 2
          : userData.departmenthead === 1
            ? 21
            : !statusID || statusID === 0
              ? 25
              : 31,
      intCategory: issueType?.id,
      intSubCategory: issueSubType?.id,
      intDepartment: (userData.role === "agent" || userData.role === "Admin") 
        ? (department?.id || parseInt(searchParams.get("deptId")) || null) 
        : (userData.role === "user" && userData.departmenthead === 0) 
          ? intDepartment 
          : (department?.id || userData.department),
      intPrioritization: prioritization?.id,
      intStatusID: statusID,
      intUserID:
        userData.role === "agent" || userData.role === "Admin" || userData.departmenthead === 1
          ? (userID || 0)
          : userData.id,
      txtFromDate: fromDate,
      txtToDate: toDate,
      intIsAdmin: isAdminState,
      txtSearch: globalFilter,
      sortBy: sorting.length > 0 ? sorting[0].id : "ticketID",
      sortOrder: sorting.length > 0 ? (sorting[0].desc ? "DESC" : "ASC") : "DESC",
      ...colFilters
    });
    config.method = "PATCH";
    config.data = data;
    config.url =
      userData.role === "agent" ||
        userData.role === "Admin" ||
        userData.departmenthead === 1
        ? agentDashboardAPI
        : userDashboardAPI;
    setIsLoading(true);
    axios(config)
      .then(function (response) {
        setTicketList(response.data["data"]);
        setTotalCount(Math.round(response.data["count"]));
        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const downloadExcel = () => {
    setExcelLoading(true);

    const colFilters = {};
    columnFilters.forEach((filter) => {
      const keyMap = {
        ticketID: "filterTicketID",
        ticketSubject: "filterSubject",
        ticketCreatedUserName: "filterEmpName",
        ticketCategory: "filterCategory",
        department: "filterDepartment",
        statusName: "filterStatusName",
        ticketType: "filterPrioritization",
        agent_name: "filterAgentName",
        assigned_by_name: "filterAdminTime",
        approvalStatus: "filterReview",
        lastAgentReplyName: "filterSubCategory",
        created_at: "filterLastReplyDate",
      };
      if (keyMap[filter.id]) {
        colFilters[keyMap[filter.id]] = filter.value;
      }
    });

    const intDepartmentLocal = parseInt(userData.department);

    const data = JSON.stringify({
      intAgentID: userData.role === "agent" ? userData.id : intAgentID,
      intLimit: 1000000,
      intOffset: 0,
      intSPType:
        (userData.role === "user" && userData.departmenthead === 0)
          ? 2
          : userData.departmenthead === 1
            ? 21
            : !statusID || statusID === 0
              ? 25
              : 31,
      intCategory: issueType?.id,
      intSubCategory: issueSubType?.id,
      intDepartment: (userData.role === "agent" || userData.role === "Admin") 
        ? (department?.id || parseInt(searchParams.get("deptId")) || null) 
        : (userData.role === "user" && userData.departmenthead === 0) 
          ? intDepartmentLocal 
          : (department?.id || userData.department),
      intPrioritization: prioritization?.id,
      intStatusID: statusID,
      intUserID:
        userData.role === "agent" || userData.role === "Admin" || userData.departmenthead === 1
          ? (userID || 0)
          : userData.id,
      txtFromDate: fromDate,
      txtToDate: toDate,
      intIsAdmin: isAdminState,
      txtSearch: globalFilter,
      sortBy: sorting.length > 0 ? sorting[0].id : "ticketID",
      sortOrder: sorting.length > 0 ? (sorting[0].desc ? "DESC" : "ASC") : "DESC",
      ...colFilters
    });

    config.method = "PATCH";
    config.data = data;
    config.url =
      userData.role === "agent" ||
        userData.role === "Admin" ||
        userData.departmenthead === 1
        ? agentDashboardAPI
        : userDashboardAPI;

    axios(config)
      .then(function (response) {
        const newData = response.data["data"].map((row) => {
          return {
            "Ticket ID": row.ticketID,
            "Subject": row.ticketSubject,
            "Created User": row.ticketCreatedUserName,
            "Category": row.ticketCategory,
            "Department": row.department,
            "Priority": row.ticketType,
            "Assigned To": row.agent_name,
            "Status": row.statusName,
            "Created At": row.created_at,
            "Department head status": row.approvalStatus
          };
        });

        const workSheet = XLSX.utils.json_to_sheet(newData);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "Tickets");
        XLSX.writeFile(workBook, `Tickets_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
        setExcelLoading(false);
        setExportSuccess(true);
      })
      .catch(function (error) {
        setExcelLoading(false);
        console.log(error);
      });
  };

  const getStatus = (data, type) => {
    config.method = "patch";
    config.url = statusAPI;
    config.data = data;

    axios(config)
      .then(function (response) {
        if (type === "issueTypeList") setIssueTypeList(response.data["data"]);
        else if (type === "issueSubTypeList")
          setIssueSubTypeList(response.data["data"]);
        else if (type === "departmentList")
          setDepartmentList(response.data["data"]);
        else if (type === "prioritizationList")
          setPrioritizationList(response.data["data"]);
        else if (type === "statusList") setStatusList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  // FILTER END

  return (
    <Layout>
      <div className={`background--white`}>
        <div className="filter-group">
          <div className="btn-group">
            <Typography>Layout: </Typography>
            <ButtonGroup
              disableElevation
              variant="contained"
              aria-label="Disabled elevation buttons"
              className="btn-group-layout"
            >
              <Button
                className={`btn-no-design ${layoutStyle === "grid" ? "active" : ""}`}
                onClick={() => setLayoutStyle("grid")}
              >
                <GridViewIcon />
              </Button>
              <Button
                className={`btn-no-design ${layoutStyle === "list" ? "active" : ""}`}
                onClick={() => setLayoutStyle("list")}
              >
                <ListIcon />
              </Button>
            </ButtonGroup>
          </div>
        </div>

        <Grid container spacing={2}>

          {/* Type - Searchable Autocomplete */}
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              options={issueTypeList}
              getOptionLabel={(option) => option.name || ""}
              value={issueType}
              onChange={handleIssueTypeChange}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderInput={(params) => (
                <TextField {...params} label="Type" fullWidth />
              )}
            />
          </Grid>

          {/* Issue Type - Searchable Autocomplete, depends on Type selection */}
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              options={issueSubTypeList}
              getOptionLabel={(option) => option.name || ""}
              value={issueSubType}
              onChange={(event, newValue) => setIssueSubType(newValue)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              disabled={!issueType}
              renderInput={(params) => (
                <TextField {...params} label="Issue Type" fullWidth />
              )}
            />
          </Grid>

          {/* Department - Searchable Autocomplete, hidden for user role */}
          {userData.role === "user" ? (
            <></>
          ) : (
            <Grid item xs={12} lg={3} md={3}>
              <Autocomplete
                options={departmentList}
                getOptionLabel={(option) => option.name || ""}
                value={department}
                onChange={(event, newValue) => setDepartment(newValue)}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                renderInput={(params) => (
                  <TextField {...params} label="Department" fullWidth />
                )}
              />
            </Grid>
          )}

          {/* Prioritization - Searchable Autocomplete */}
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              options={prioritizationList}
              getOptionLabel={(option) => option.name || ""}
              value={prioritization}
              onChange={(event, newValue) => setPrioritization(newValue)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderInput={(params) => (
                <TextField {...params} label="Prioritization" fullWidth />
              )}
            />
          </Grid>

          {/* Ticket Status - Searchable Autocomplete */}
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              options={statusList}
              getOptionLabel={(option) => option.name || ""}
              value={statusID}
              onChange={(event, newValue) => setStatusID(newValue)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderInput={(params) => (
                <TextField {...params} label="Ticket Status" fullWidth />
              )}
            />
          </Grid>

          {/* User - Searchable Autocomplete (unchanged) */}
          {userData.role === "user" ? (
            <></>
          ) : (
            <Grid item xs={12} lg={3} md={3}>
              <FormControl className={`form-control`} fullWidth>
                <Autocomplete
                  id="combo-box-demo"
                  options={userList}
                  getOptionLabel={(option) =>
                    option.emp_no + " - " + option.username
                  }
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} label="User" variant="outlined" />
                  )}
                  onChange={(event, newValue) => {
                    setUserID(0);
                    if (newValue !== null) {
                      setUserID(newValue.id);
                    }
                  }}
                />
              </FormControl>
            </Grid>
          )}

          {/* Agent - Searchable Autocomplete (unchanged) */}
          {userData.role === "user" || userData.role === "agent" ? (
            <></>
          ) : (
            <Grid item xs={12} lg={3} md={3}>
              <FormControl fullWidth>
                <Autocomplete
                  id="grouped-demo"
                  options={optionsAgent || []}
                  groupBy={(option) => option?.firstLetter}
                  getOptionLabel={(option) => option?.name || ""}
                  value={selectedAgentObj}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} label="IT Admin" />
                  )}
                  onChange={(event, newValue) => {
                    setSelectedAgentObj(newValue);
                    if (newValue !== null) {
                      setAgentID(newValue.id);
                    } else {
                      setAgentID(0);
                    }
                  }}
                  className={` `}
                />
              </FormControl>
            </Grid>
          )}

          {/* Date Range - Professional Picker */}
          <Grid item xs={12} lg={3} md={3}>
            <div className="date-picker-container" style={{ width: '100%' }}>
              <DatePicker
                selectsRange={true}
                startDate={fromDate ? new Date(fromDate) : null}
                endDate={toDate ? new Date(toDate) : null}
                onChange={(update) => {
                  const [start, end] = update;
                  setFromDate(start ? moment(start).format("YYYY-MM-DD") : "");
                  setToDate(end ? moment(end).format("YYYY-MM-DD") : "");
                }}
                isClearable={true}
                placeholderText="Select Date Range"
                className="custom-date-picker"
                dateFormat="yyyy-MM-dd"
                portalId="root"
              />
            </div>
          </Grid>

          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            textAlign={`center`}
            display={`flex`}
            justifyContent={`center`}
            gap={`10px`}
          >
            <Button
              className="btn-primary"
              onClick={() => fetchData(1)}
              startIcon={<Search />}
            >
              Search
            </Button>

            <Button
              className="btn-primary"
              onClick={() => window.location.reload()}
            >
              Reset Search
            </Button>
          </Grid>
        </Grid>
      </div>

      {/* ── Color Legend Strip — shown once, above all cards ── */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "8px 20px",
          padding: "12px 4px 14px 4px",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#555", whiteSpace: "nowrap" }}>
          Ticket Status :
        </Typography>
        {STATUS_COLOR_LEGEND.map((item) => (
          <Box key={item.label} sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Box sx={{
              width: "14px", height: "14px", borderRadius: "50%",
              backgroundColor: item.color, flexShrink: 0,
            }} />
            <Typography sx={{ fontSize: "15px", color: "#555", whiteSpace: "nowrap" }}>
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} textAlign="right">
          <Button
            variant="contained"
            className="btn-primary"
            onClick={downloadExcel}
            startIcon={<GetAppIcon />}
            sx={{ mb: 1 }}
          >
            Export to Excel
          </Button>
        </Grid>
      </Grid>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={excelLoading}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Exporting Excel...
        </Typography>
      </Backdrop>

      <Snackbar
        open={exportSuccess}
        autoHideDuration={3000}
        onClose={() => setExportSuccess(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert elevation={6} variant="filled" severity="success" onClose={() => setExportSuccess(false)}>
          Excel file exported successfully!
        </Alert>
      </Snackbar>

      <div style={{ marginTop: "20px" }}>
        <MaterialReactTable
          columns={[
            {
              id: "slNo",
              header: "Sl. No",
              accessorFn: (row, index) => (pagination.pageIndex * pagination.pageSize) + index + 1,
              size: 50,
              enableColumnFilter: false,
              enableSorting: false,
            },
            {
              accessorKey: "ticketID",
              header: "Ticket ID",
              size: 100,
              Cell: ({ cell, row }) => (
                <Tooltip title="Click to Edit Ticket" arrow>
                  <Typography
                    onClick={() => navigate(editPageBaseURL + row.original.ticketID)}
                    sx={{
                      color: '#1976d2',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontWeight: 500
                    }}
                  >
                    {cell.getValue()}
                  </Typography>
                </Tooltip>
              )
            },
            {
              accessorKey: "ticketSubject",
              header: "Subject",
              size: 250,
              Cell: ({ row }) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {row.original.ticketSubject}
                  </Typography>
                  {row.original.submitted_by_admin && (
                    <Box
                      component="span"
                      sx={{
                        backgroundColor: "#2e7d32",
                        color: "white",
                        fontSize: "9px",
                        fontWeight: "700",
                        padding: "1px 6px",
                        borderRadius: "10px",
                        textTransform: "uppercase",
                        display: "inline-block",
                        width: 'fit-content'
                      }}
                    >
                      Created by Admin
                    </Box>
                  )}
                </Box>
              )
            },
            {
              accessorKey: "ticketCreatedUserName",
              header: "Created User",
            },
            {
              accessorKey: "ticketCategory",
              header: "Category",
            },
            {
              accessorKey: "statusName",
              header: "Status",
              size: 150,
              Cell: ({ cell, row }) => (
                <Box
                  sx={{
                    backgroundColor: STATUS_COLOR_LEGEND.find(l => l.label === cell.getValue())?.color || '#ccc',
                    color: '#fff',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    textAlign: 'center'
                  }}
                >
                  {cell.getValue()}
                </Box>
              )
            },
            {
              accessorKey: "ticketType",
              header: "Priority",
            },
            {
              accessorFn: (row) => row.agent_name || "-",
              id: "agent_name",
              header: "Assigned To",
            },
            {
              accessorFn: (row) => row.assigned_by_name || "-",
              id: "assigned_by_name",
              header: "Assigned By",
            },
            {
              accessorKey: "department",
              header: "Department",
            },
            {
              accessorFn: (row) => row.approvalStatus || "Not Approved",
              id: "approvalStatus",
              header: "Department head status",
            },
            {
              accessorFn: (row) => row.lastAgentReplyName || "-",
              id: "lastAgentReplyName",
              header: "Last Reply By",
            },
            {
              accessorKey: "created_at",
              header: "Created At",
            },
            {
              id: "edit",
              header: "Edit",
              size: 80,
              Cell: ({ row }) => (
                <Tooltip title="Edit Ticket" arrow>
                  <Box
                    onClick={() => navigate(editPageBaseURL + row.original.ticketID)}
                    sx={{
                      cursor: "pointer",
                      display: 'flex',
                      justifyContent: 'center',
                      color: '#1976d2'
                    }}
                  >
                    <Edit fontSize="small" />
                  </Box>
                </Tooltip>
              ),
            },
          ]}
          data={ticketList}
          manualFiltering
          manualPagination
          manualSorting
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          onColumnFiltersChange={setColumnFilters}
          rowCount={totalCount}
          enableColumnPinning
          state={{
            globalFilter,
            isLoading,
            pagination,
            sorting,
            columnFilters,
            columnPinning: {
              right: ["edit"],
            },
          }}
          enableGlobalFilter={true}
          enableFullScreenToggle={false}
          enableDensityToggle={false}
          enableHiding={false}
          enableStickyHeader={true}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              // Row click removed as per request
            },
          })}
          muiTableContainerProps={{
            sx: {
              maxHeight: '600px',
            },
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid #e0e0e0",
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              backgroundColor: "#a278d6", 
              color: "#fff",
              fontWeight: "bold",
              '&[data-pinned="true"]': {
                backgroundColor: "#a278d6",
                opacity: 1,
              },
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              backgroundColor: "#fff",
              '&[data-pinned="true"]': {
                backgroundColor: "#fff",
                opacity: 1,
              },
            },
          }}
        />
      </div>
    </Layout>
  );
}